function maybeClick() {
	const element = document.querySelector('.wc-block-components-address-card__edit');

	if (!element) {
		return false;
	}

	if (
		document.querySelector('.wc-block-components-address-form__first_name input')?.value
		&& document.querySelector('.wc-block-components-address-form__last_name input')?.value
		&& document.querySelector('.wc-block-components-address-form__postcode input')?.value
		&& document.querySelector('.wc-block-components-address-form__city input')?.value
	) {
		return false;
	}

	element.click();

	return true;
}

export function init() {
	if (!document.body.classList.contains('woocommerce-checkout')) {
		return;
	}

	const clicked = maybeClick();

	if (clicked) {
		return;
	}

	setTimeout(() => {
		maybeClick();
	}, 1000);
}
